angular.module('invoice')
    .component('invoiceCostTypeList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/cost-type/list.html',
        controller: function ($scope, $state, $httpParamSerializer, $stateParams, Principal, InvoiceCostTypeService, InvoiceService) {
            this.reset = () => this.filters = {}
            this.InvoiceService = InvoiceService
            this.InvoiceCostTypeService = InvoiceCostTypeService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_INVOICE_SETTINGS_WRITE'])
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-cost-type-batch/export?" + $httpParamSerializer(paramsAll)
            }

            $scope.$on('invoice-cost-type.updated', () => $state.reload())
        }
    })
